import { Button } from "antd";
import { useTranslation } from "react-i18next";

const LoginButton = ({ handlelogin, loading }) => {
  const { t } = useTranslation();
  return (
    <div className="mt-6">
      <Button
        disabled={loading}
        loading={loading}
        onClick={() => handlelogin()}
        block
        className="login-button  justify-center"
      >
        {t("login-button")}
      </Button>
    </div>
  );
};
export default LoginButton;
